import api from '@/plugins/api'
import { statement, statementManual } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'

export default {
  state: () => ({
    isLoad: false
  }),
  actions: {
    async setMedia (context, data) {
      return Promise.all(data.body.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)

        item.files.forEach(file => {
          body.append('files', file)
        })
        return data.vehicle_condition !== 'NewManual'
          ? await api.post(statement.media(data.id), { body: body })
          : await api.post(statementManual.uploadMedia(data.id), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    async downloadFile (context, url) {
      const response = await api.get(url, { responseType: 'blob' })
      if (await requestValidation(response)) {
        window.open(URL.createObjectURL(response.data), '_blank')
      }
    }
  }
}
